export default __webpack_public_path__ + "media/src/assets/images/rebill_display-dce51b7137a19d5f41cc0d444fe51db9.png";